import React from 'react';
import {Link} from 'react-router-dom';
import style from './style.scss';
import {MasterLayout} from 'components/layouts';
import title from 'constants/TitlePages.js';

class ThankPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.ThankPage;
  }

  render() {
    return (
      <MasterLayout>
        <section className='thank-wrapper-A'>
          <p className='thank-icon'></p>
          <h2 className='thank-title'>Cảm ơn bạn đã hoàn thành!</h2>
          <p className='thank-desc'>Nunc facilisis eu enim non sodales fusce at porta tellus. Cras ac tellus vestibulum. Cras ac tellus vestibulum. Cras ac tellus vestibulum.</p>
          <p className='thank-back-to-home'>
            Quay trở lại&nbsp;<Link className='thank-link' to='/'>Trang chủ</Link>
          </p>
        </section>
      </MasterLayout>
    );
  }
}

export default ThankPage;


// WEBPACK FOOTER //
// ./pages/thank/ThankPage.jsx